'use client';

import * as React from 'react';
import { initChatwoot } from 'app/root/[isEU]/_components/chat-widget';
import { CHAT_WIDGET_DISABLED_KEY } from './(dashboard)/(root)/account/general';
import { useAppCookieConsent } from './app-cookie-consent';

type ChatWidgetProps = {
  isEU: boolean;
};

export function AppChatWidget(props: ChatWidgetProps): JSX.Element {
  const { isAcceptedAll } = useAppCookieConsent();
  React.useEffect(() => {
    if (props.isEU && !isAcceptedAll) {
      return;
    }

    const isChatDisabled =
      localStorage.getItem(CHAT_WIDGET_DISABLED_KEY) === 'true';
    if (isChatDisabled) {
      return;
    }

    const id = setTimeout(() => {
      initChatwoot();
    }, 500);

    return () => {
      clearTimeout(id);
    };
  }, [props, isAcceptedAll]);

  return <></>;
}
